<template lang="pug">
  div
    #scrollerWrapper
      #scroller
        slot(name="content")
</template>

<script>
/* eslint-disable no-new */
export default {
  mounted() {
    setTimeout(function () {
      new this.IScroll('#scrollerWrapper', {
        mouseWheel: true
      })
    }, 100)
  },
  updated() {
    new this.IScroll('#scrollerWrapper', {
      mouseWheel: true
    })
  }
}
</script>

<style lang="less" scoped>
#scrollerWrapper {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: hidden;

  /* Prevent the callout on tap-hold and text selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Prevent text resize on orientation change, useful for web-apps */
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  -webkit-overflow-scrolling: touch;
}

#scroller {
  width: 100%;
  position: absolute;

  /* Prevent elements to be highlighted on tap */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* Put the scroller into the HW Compositing layer right from the start */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-overflow-scrolling: touch;
}
</style>
